export default "/images/be9206fdc0a80889d978d5bf6d6da775.avif";